export const VIPPS_MEMBERSHIP_SESSION_KEY = 'naf:become-a-member:vipps';
export const WITHOUT_VIPPS_MEMBERSHIP_SESSION_KEY = 'naf:become-a-member:without-vipps';
export const VIPPS_MEMBERSHIP_REGISTRATION_METHOD_KEY = 'naf:become-a-member:registration-method';
const CHECKOUT_REGISTRATION_METHOD_TRACKING_KEY = 'checkout_registration_method';
type VippsMembershipRegistrationMethod = 'vipps' | 'manual';

const getSessionStorage = () => (typeof window !== 'undefined' ? window.sessionStorage : undefined);
const getLocalStorage = () => (typeof window !== 'undefined' ? window.localStorage : undefined);

export const hasStartedVippsMembership = () => getSessionStorage()?.getItem(VIPPS_MEMBERSHIP_SESSION_KEY) === 'true';

export const hasChosenWithoutVipps = () =>
  getSessionStorage()?.getItem(WITHOUT_VIPPS_MEMBERSHIP_SESSION_KEY) === 'true';

export const didUseVippsMembershipRegistrationMethod = () => {
  const storedMethod =
    getSessionStorage()?.getItem(VIPPS_MEMBERSHIP_REGISTRATION_METHOD_KEY) ??
    getLocalStorage()?.getItem(VIPPS_MEMBERSHIP_REGISTRATION_METHOD_KEY);
  if (storedMethod === 'vipps') return true;
  if (storedMethod === 'manual') return false;
  if (hasStartedVippsMembership()) return true;
  return false;
};

export const clearVippsMembershipRegistrationMethod = () => {
  getSessionStorage()?.removeItem(VIPPS_MEMBERSHIP_REGISTRATION_METHOD_KEY);
  getLocalStorage()?.removeItem(VIPPS_MEMBERSHIP_REGISTRATION_METHOD_KEY);
};

export const markVippsMembershipRegistrationMethod = (method: VippsMembershipRegistrationMethod) => {
  getSessionStorage()?.setItem(VIPPS_MEMBERSHIP_REGISTRATION_METHOD_KEY, method);
  getLocalStorage()?.setItem(VIPPS_MEMBERSHIP_REGISTRATION_METHOD_KEY, method);
};

const getVippsMembershipRegistrationMethodTrackingValue = (
  didUseVipps?: boolean,
): VippsMembershipRegistrationMethod | undefined => {
  if (didUseVipps === undefined) return undefined;
  return didUseVipps ? 'vipps' : 'manual';
};

export const getVippsMembershipRegistrationMethodTrackingPayload = (didUseVipps?: boolean) => {
  const registrationMethod = getVippsMembershipRegistrationMethodTrackingValue(didUseVipps);
  return registrationMethod ? { [CHECKOUT_REGISTRATION_METHOD_TRACKING_KEY]: registrationMethod } : {};
};

export const markVippsMembershipStarted = () => {
  const storage = getSessionStorage();
  storage?.setItem(VIPPS_MEMBERSHIP_SESSION_KEY, 'true');
  markVippsMembershipRegistrationMethod('vipps');
};

export const markContinueWithoutVipps = () => {
  const storage = getSessionStorage();
  storage?.setItem(WITHOUT_VIPPS_MEMBERSHIP_SESSION_KEY, 'true');
  markVippsMembershipRegistrationMethod('manual');
};

export const clearVippsMembershipSession = () => {
  const storage = getSessionStorage();
  storage?.removeItem(VIPPS_MEMBERSHIP_SESSION_KEY);
  storage?.removeItem(WITHOUT_VIPPS_MEMBERSHIP_SESSION_KEY);
};
